import React from "react";
import "./Preloader.scss";

// Full-viewport loading spinner.
//
// DUPLICATE of src/components/UI/Preloader - see shared/README.md. Extracted
// blocks import this copy; App.js and MarketPage still use the original until
// the maintenance pass reconciles them. The markup and class names are kept
// identical so both copies render the same thing.
function Preloader() {
  return (
    <div className="preloader">
      <div className="spinner"></div>
    </div>
  );
}

export default Preloader;
